import { formatValues } from "../../components/datatable/GridValuesFormatter";
import { DisplayValues, RowItemData } from "../../components/datatable/interfaces";
import { RowResponse } from "../../api-models/response/DataGridResponse";
import { IssueSeverity } from "../../generated/SewerObjects";

export interface AddedDamageDisplayForDiagram {
  videoPosition: number;
  mainCode: string;
}

export class Damage implements RowItemData {
  id: number;
  private properties: DisplayValues;
  private hasIssues: boolean;
  private maxIssueSeverity: IssueSeverity;

  constructor(damageRow: RowResponse) {
    this.id = damageRow.id;
    this.properties = damageRow.details;
    this.hasIssues = damageRow.hasIssues!;
    this.maxIssueSeverity = damageRow.maxIssueSeverity!;
    this.properties.DamageNumber = {
      ...this.properties.DamageNumber,
      id: this.id,
      path: "damages/:id",
      hasIssues: this.hasIssues,
      maxIssueSeverity: this.maxIssueSeverity,
      entityName: this.entityName,
    };
  }

  get diagramDetails(): AddedDamageDisplayForDiagram {
    return {
      videoPosition: this.properties.VIDEOPOSITION.value,
      mainCode: this.properties.BM105.value,
    };
  }

  get displayValues() {
    this.properties = formatValues(this.properties);

    return this.properties;
  }

  private get entityName() {
    return "Damage";
  }

  videoPositionOnClick(handleVideoPositionClick: any) {
    if (this.properties) {
      this.properties = {
        ...this.properties,
        VIDEOPOSITION: {
          ...this.properties.VIDEOPOSITION,
          onClick: () => handleVideoPositionClick(this.id),
        },
      };
    }
  }
}
